import { FORM_PROXIES } from "routes";
import { globs } from "./globs";
import {
	Action, 
	Any 
} from "./security/actionScopes";

export const PROXY_TYPES = {
	operation: "OPERATION",
	query: "QUERY",
	system: "SYSTEM",
	report: "REPORT"
};

const QUERY_TYPE_TO_SECURITY_TYPE_MAP = {
	[PROXY_TYPES.operation]: "OPERATIONS",
	[PROXY_TYPES.query]: "ANALYTICS",
	[PROXY_TYPES.system]: "SYSTEM",
	[PROXY_TYPES.report]: "REPORTING"
};

function ProxyService(
	api,
	$logger,
	securityService
) {
	const service = this;

	service.clearProxies = () => {
		service.proxiesByType = Object.values(PROXY_TYPES).reduce((acc, next) => {
			acc[next] = [];

			return acc;
		}, {});
	};

	service.loadProxies = (formId) => {
		const url = FORM_PROXIES(formId);
		
		const proxyLoading = api.get(url).then(response => {
			const canUseProxyGlob = (type, code) => globs.proxies.byType(type).endpoints.byCode(code).read;
			service.proxies = response.filter(p => {
				const proxyGlob = canUseProxyGlob(p.Type.Code, p.Code);
				const securityGlob = canUseProxyGlob(QUERY_TYPE_TO_SECURITY_TYPE_MAP[p.Type.Code], p.Code);

				const proxyAction = new Action(proxyGlob);
				const securityAction = new Action(securityGlob);

				const isAllowed = securityService.isActionScopeAllowed(new Any([proxyAction, securityAction]));

				return isAllowed;
			});

			service.proxiesByType = Object.values(PROXY_TYPES).reduce((acc, next) => {
				acc[next] = service.proxies.filter((d) => d.Type.Code === next);

				return acc;
			}, {});

			return response;
		});

		return proxyLoading;
	};

	service.getProxiesByType = (types) => {
		const proxies = types.reduce((acc, next) => {
			acc = acc.concat(service.proxiesByType[next]);

			return acc;
		}, []);

		return proxies;
	};

	return service;
}

export default angular
	.module("vesl.services.proxy-service", [])
	.service("proxyService", ProxyService).name;